import { defineComponent as _, useAttrs as I, useId as E, computed as l, ref as u, watchEffect as V, createElementBlock as i, openBlock as n, mergeProps as h, createElementVNode as a, createVNode as v, unref as b, createCommentVNode as f, renderSlot as s, normalizeClass as z, normalizeStyle as N, withCtx as R } from "vue";
import { useResizeObserver as S } from "@vueuse/core";
import T from "../../icons/generated/IconChevronDown.vue2.js";
import { tw as g } from "../../utils/tailwind.js";
import F from "./components/TransitionContent.vue2.js";
const H = ["id", "aria-controls", "aria-disabled", "aria-expanded", "disabled"], L = {
  key: 0,
  class: "mr-8 block size-24"
}, O = { class: "flex grow flex-col" }, P = { class: "flex grow flex-row items-start" }, j = { class: "text-action-default-hi body-1 w-full max-w-full" }, q = { class: "ml-auto block" }, D = {
  key: 0,
  class: "body-2 w-full max-w-full"
}, G = ["id"], X = /* @__PURE__ */ _({
  name: "RevAccordionItem",
  inheritAttrs: !1,
  __name: "AccordionItem",
  props: {
    collapsed: { default: "auto" },
    disabled: { type: Boolean, default: !1 },
    wrapperAttrs: { default: () => ({}) },
    keepContentAlive: { type: Boolean, default: !1 },
    renderBody: { type: Boolean, default: !1 },
    disableChevronAnimation: { type: Boolean, default: !1 }
  },
  emits: ["click"],
  setup(o, { emit: y }) {
    const r = o, w = y, C = I(), p = E(), x = l(() => `accordion-trigger-${p}`), m = l(() => `accordion-content-${p}`), t = u(!1);
    V(() => {
      const e = {
        auto: !1,
        expanded: !0,
        collapsed: !1
      };
      t.value = e[r.collapsed];
    });
    const k = l(() => r.collapsed === "auto");
    function A(e) {
      w("click", e), k.value && (t.value = !t.value);
    }
    const $ = l(() => r.disableChevronAnimation ? "" : [
      g`transition-transform duration-200 ease-in`,
      t.value && g`rotate-180`
    ]), d = u(), c = u(t.value ? "auto" : "0px");
    function B(e) {
      t.value || (e.setAttribute("style", "height: 0px"), c.value = "0px");
    }
    return S(d, () => {
      t.value && (c.value = `${d.value.getBoundingClientRect().height}px`);
    }), (e, J) => (n(), i("li", h(o.wrapperAttrs, { class: "relative list-none tap-highlight-transparent" }), [
      a("button", h(b(C), {
        id: x.value,
        "aria-controls": m.value,
        "aria-disabled": o.disabled,
        "aria-expanded": t.value,
        class: "bg-static-default-min text-static-default-low focus-visible-outline-default-hi flex w-full cursor-pointer items-start overflow-hidden rounded-none border-0 px-24 py-20 text-left no-underline hover:bg-static-default-min-hover motion-safe:transition motion-safe:duration-200",
        disabled: o.disabled,
        onClick: A
      }), [
        e.$slots.prefix ? (n(), i("span", L, [
          s(e.$slots, "prefix")
        ])) : f("", !0),
        a("span", O, [
          a("span", P, [
            a("span", j, [
              s(e.$slots, "title")
            ]),
            a("span", q, [
              e.$slots.image ? f("", !0) : (n(), i("span", {
                key: 0,
                class: z(["block h-24", $.value])
              }, [
                v(b(T))
              ], 2)),
              s(e.$slots, "image")
            ])
          ]),
          e.$slots.description ? (n(), i("span", D, [
            s(e.$slots, "description")
          ])) : f("", !0)
        ])
      ], 16, H),
      v(F, {
        class: "text-static-default-mid body-2",
        condition: t.value,
        "keep-alive": o.keepContentAlive,
        "render-body": o.renderBody,
        style: N({ height: c.value }),
        "transition-props": {
          enterActiveClass: "overflow-y-hidden transition-height duration-300 ease-in will-change-[height]",
          enterFromClass: "h-0",
          leaveActiveClass: "overflow-y-hidden transition-height duration-300 ease-in will-change-[height]",
          leaveToClass: "h-0"
        },
        onLeave: B
      }, {
        default: R(() => [
          a("div", {
            id: m.value,
            ref_key: "accordionContentEl",
            ref: d,
            class: "px-24 pb-20 pt-8"
          }, [
            s(e.$slots, "body")
          ], 8, G)
        ]),
        _: 3
      }, 8, ["condition", "keep-alive", "render-body", "style"])
    ], 16));
  }
});
export {
  X as default
};
